import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ChamadoDto } from 'app/models/chamado-dto.model';
import { RespostaChamadoDto } from 'app/models/resposta-chamado-dto.model';
import { AbChamado } from 'app/abstract/full-pages/chamado/chamado.abstract';

@Injectable({ providedIn: 'root' })
export class ChamadoService extends AbChamado {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllCategoriasChamados(filter: string): Observable<any> {
    return this.get(`categorias_chamados/filter/${filter}`);
  }

  public saveCategoriaChamado(categoriaChamado: any): Observable<any> {
    return this.save('categorias_chamados/', categoriaChamado);
  }

  public getCategoriaChamado(id: number) {
    return this.get('categorias_chamados/', id);
  }

  public deleteCategoriaChamado(entityId: number) {
    return this.delete('categorias_chamados/', entityId);
  }

  public getAllCategoriaChamado() {
    return this.get("categorias_chamados/all/");
  }

  public getAllChamadosFilter(filter: string): Observable<any> {
    return this.get(`chamados/filter/${filter}`);
  }

  public deleteChamado(entityId: number) {
    return this.delete('chamados/', entityId);
  }

  public getChamadoById(id:number, checkId: number): Observable<any> {
    return this.get(`chamados/chamado/${id}/${checkId}`);
  }

  public saveChamado(chamado: ChamadoDto): Observable<any> {
    return this.save('chamados/chamado/', chamado);
  }

  public downloadAnexoChamado(id: number, nomeAnexo: string): Observable<any> {
    return this.get(`chamadoanexos/download/${id}/${nomeAnexo}`);
  }

  public deleteAnexoChamado(id: number): Observable<any> {
    return this.delete('chamadoanexos/', id);
  }

  public getRespostaChamados(idChamado: number, checkId: number): Observable<any> {
    return this.get(`resposta_chamados/chamadoId/${idChamado}/${checkId}`);
  }

  public saveRespostaChamado(resposta: RespostaChamadoDto): Observable<any> {
    return this.save('resposta_chamados/chamado/', resposta);
  }

  public getRelatorioId(id: number, checkId: number): Observable<any> {
    return this.get(`chamados/relatorios/${id}/${checkId}`);
  }

  public getListarRelatorio(filter: string): Observable<any> {
    return this.get(`chamados/relatorio/listar/${filter}`);
  }

  public getRelatorio(filter: string, tipo: string): Observable<any> {
    return this.get(`chamados/relatorio/${filter}/${tipo}`);
  }

}
